import { flatten, values } from "lodash";
import { isRequestActive, LoadingState } from "redux-request-loading";
import {
    SUBMIT_QUESTIONNAIRE,
    validateQuestion,
    nextSection,
    updateQuestion,
    registerSection,
    registerSectionIndexIfNeeded,
    removeQuestion,
    removeSection
} from "@teamprevent/common/questionnaires/actions";

import { QuestionnaireContainerStateProps, QuestionnaireContainerOwnProps } from "./QuestionnaireContainerProps";
import { QuestionnairesState, QuestionMap, Section } from "./model";
import { QuestionnaireSectionDispatchProps, QuestionnaireSectionOwnProps, QuestionnaireSectionStateProps } from "./QuestionnaireSectionProps";

import { Location } from "redux-little-router";

const mapStateToQuestionnaireContainerProps =
    (state: { questionnaires: QuestionnairesState; router: Location } & LoadingState,
        ownProps: QuestionnaireContainerOwnProps): QuestionnaireContainerStateProps => {
        let isValid;
        if (state.questionnaires[ownProps.questionnaireKey]) {
            if (state.questionnaires[ownProps.questionnaireKey].sections.every(section => section.isValid === true)) {
                isValid = true;
            } else if (state.questionnaires[ownProps.questionnaireKey].sections.some(section => section.isValid === false)) {
                isValid = false;
            }
        }
        return {
            submittingQuestionnaire: isRequestActive(state, SUBMIT_QUESTIONNAIRE),
            questions: state.questionnaires[ownProps.questionnaireKey] ?
                flatten(state.questionnaires[ownProps.questionnaireKey].sections.map(section => values(section.questions))) :
                [],
            isValid
        };
    };

const makeMapStateToQuestionnaireSectionProps = (sectionId: string) => {
    return (state: { questionnaires: QuestionnairesState }, ownProps: any) => mapStateToQuestionnaireSectionProps(state, { ...ownProps, id: sectionId });
};

const mapStateToQuestionnaireSectionProps = (
    state: {
        questionnaires: QuestionnairesState;
    },
    ownProps: QuestionnaireSectionOwnProps): QuestionnaireSectionStateProps => {

    const sections = (state.questionnaires[ownProps.questionnaireKey] && state.questionnaires[ownProps.questionnaireKey].sections) || [];
    const section = sections.find(s => s.id === ownProps.id) || {} as Section;
    const questions: QuestionMap = section.questions || {};
    return {
        questions,
        active: ownProps.active || section.active,
        isValid: section.isValid,
        currentSectionIndex: section.index,
        isComplete: section.isComplete,
        sections,
    };
};

const mapDispatchToQuestionnaireSectionProps = (dispatch: any): QuestionnaireSectionDispatchProps => ({
    registerSection: payload => dispatch(registerSection(payload)),
    registerSectionIndexIfNeeded: payload => dispatch(registerSectionIndexIfNeeded(payload)),
    updateAnswer: payload => dispatch(updateQuestion(payload)),
    nextSection: payload => dispatch(nextSection(payload)),
    validateQuestion: payload => dispatch(validateQuestion(payload)),
    removeQuestion: payload => dispatch(removeQuestion(payload)),
    removeSection: payload => dispatch(removeSection(payload.questionnaireKey, payload.sectionId))
});

export {
    mapStateToQuestionnaireContainerProps,
    mapStateToQuestionnaireSectionProps,
    mapDispatchToQuestionnaireSectionProps,
    makeMapStateToQuestionnaireSectionProps
};
